import { BlockError } from '@/blocks.04-project/block-error/block-error';
import { LazyInit } from '@/blocks.04-project/lazy-init/lazy-init';
import toArray from 'lodash-es/toArray';
import { PaginationEvents } from '@/blocks.04-project/slider-pagination/slider-pagination';

/***
 * Класс слайдера для акций
 */
class PromotionsSlider {
  /***
   * Конструктор класса
   * @param elem {HTMLElement} DOM элемент формы с классом promotions-slider
   */
  constructor(elem) {
    this.BlockError = new BlockError({ blockName: 'PromotionsSlider', destroy: this.destroy });

    if (!elem) return this.BlockError.error('Отсутствует elem');
    this.block = elem;
    this.block.PromotionsSlider = this;
    this.block.AsyncPromotionsSlider = new Promise((resolve) => {
      this.promiseResolve = resolve;
    }).then((ins) => ins);

    this.LazyInit = new LazyInit({ ins: this, callback: this.init, addClass: 'promotions-slider_inited' });
    this.LazyInit.init();
  }

  init = async () => {
    this.paginationContainer = this.block.querySelector('.swiper-pagination');
    if (!this.paginationContainer) return this.BlockError.error('Отсутствует .swiper-pagination');

    this.navNext = this.block.querySelector('.swiper-button-next');
    if (!this.navNext) return this.BlockError.error('Отсутствует .swiper-button-next');

    this.navPrev = this.block.querySelector('.swiper-button-prev');
    if (!this.navPrev) return this.BlockError.error('Отсутствует .swiper-button-prev');

    const { Swiper, Modules } = await Promise.all([
      import(/* webpackChunkName: "Swiper" */ 'swiper'),
      import(
        /* webpackChunkName: "SwiperModules" */
        /* webpackExports: ['Navigation', 'Pagination'] */
        'swiper/modules')
    ]).then((data) => {
      return {
        Swiper: data[0]?.Swiper,
        Modules: toArray(data[1]),
      };
    }).catch((err) => {
      throw new Error(err);
    });

    this.swiper = new Swiper(this.block.querySelector('.swiper'), {
      slidesPerView: 1,
      spaceBetween: 50,
      loop: true,
      navigation: {
        nextEl: this.navNext,
        prevEl: this.navPrev,
      },
      pagination: {
        el: this.paginationContainer,
        type: 'bullets',
        clickable: true,
      },
      on: {
        ...PaginationEvents,
        afterInit: (swiper) => this.block.dispatchEvent(new CustomEvent('iv.swiper.inited', { bubbles: true, detail: swiper })),
      },
      modules: Modules,
    });

    this.promiseResolve(this);
    this.block.AsyncPromotionsSlider = this;
  };

  destroy = () => {
    if (this.swiper) this.swiper.destroy();
    if (this.LazyInit) this.LazyInit.destroy();
    if (this.block) {
      this.block.classList.remove('promotions-slider_inited');
      delete this.block.PromotionsSlider;
      delete this.block.AsyncPromotionsSlider;
    }
  };

  static init() {
    Array.from(document.querySelectorAll('.promotions-slider:not(.promotions-slider_inited)')).forEach((elem) => new PromotionsSlider(elem));
  }
}

document.addEventListener('DOMContentLoaded', PromotionsSlider.init);

// Экспорт;
window.Block.PromotionsSlider = PromotionsSlider;
